export const getVariantColor = (key: string, type: string): string =>
{
    switch (type)
    {
        default:
            return "secondary";
    }
};
